"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _Button = require("@ccw-pwa-ui/Button");
var _ConnectionLoader = require("@ccw-pwa-ui/ConnectionLoader");
var _AccessoryButton = require("@ccw-pwa-ui/AccessoryButton");
var _react = _interopRequireDefault(require("react"));
require("../../styles/AddAccessoryComponent.css");
var _index = _interopRequireDefault(require("../../common_features/assets/images/index"));
const AddAccessoryComponent = _ref => {
  let {
    totalPage,
    currentPage,
    navHeading,
    rightNavHeading,
    handleCancle,
    handleBack,
    headerText,
    subContent,
    continueBtnTitle,
    continueBtnClick,
    continueBtnDisabled,
    accessoryList,
    handleReduceBtn,
    handleAddBtn,
    modelNumber,
    isLoading,
    pageNumberNotShow
  } = _ref;
  return isLoading ? /*#__PURE__*/_react.default.createElement(_ConnectionLoader.ConnectionLoader, null) : /*#__PURE__*/_react.default.createElement("div", {
    className: "addAccessory-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: navHeading,
    rightNavHeading: rightNavHeading,
    handleCancle: handleCancle,
    handleBack: handleBack,
    leftArrowImage: _index.default.leftArrow.default
  }), !pageNumberNotShow ? /*#__PURE__*/_react.default.createElement("div", {
    className: "PageCount"
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontWeight: 600
    }
  }, "Step ", currentPage, " "), " of ", totalPage) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "addAccessory-body-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "addAccessory-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: !pageNumberNotShow ? "addAccessory-heading" : "addAccessory-heading-2"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: headerText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "addAccessory-subContent"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "sub-text",
    headerText: subContent
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "model-number-label"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: modelNumber
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "addAccessory-list-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_AccessoryButton.AccessoryButton, {
    handleReduceBtn: handleReduceBtn,
    handleAddBtn: handleAddBtn,
    rightBtnImage: _index.default.roundNegativeBtn.default,
    leftBtnImage: _index.default.roundPositiveBtn.default,
    deviceImage: _index.default.galTank.default,
    list: accessoryList,
    defaultAccessoryImg: _index.default.noImg.default
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "addAccessory-btn"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: continueBtnTitle,
    onClick: continueBtnClick,
    disabled: continueBtnDisabled
  })))));
};
var _default = exports.default = AddAccessoryComponent;